import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/roi')({
  beforeLoad: () => getTitleContextSlice('ROI'),
  staticData: {
    owner: CodeOwner.Uvm,
  },
});
